import { render, staticRenderFns } from "./Externalities.vue?vue&type=template&id=e4c5ad3c&scoped=true&"
import script from "./Externalities.vue?vue&type=script&lang=js&"
export * from "./Externalities.vue?vue&type=script&lang=js&"
import style0 from "./Externalities.vue?vue&type=style&index=0&id=e4c5ad3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c5ad3c",
  null
  
)

export default component.exports